import { render, staticRenderFns } from "./Society.vue?vue&type=template&id=073ebeaa&scoped=true&"
import script from "./Society.vue?vue&type=script&lang=js&"
export * from "./Society.vue?vue&type=script&lang=js&"
import style0 from "./Society.vue?vue&type=style&index=0&id=073ebeaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073ebeaa",
  null
  
)

export default component.exports